import styled from "styled-components";
import { colorsPalettes, setFont } from "@similarweb/styles";

const { carbon, blue } = colorsPalettes;

const DEFAULT_COLOR = blue[400];
const BOLD_COLOR = blue[500];
const DISABLED_COLOR = carbon[200];

export const ImportDomainsContainer = styled.div`
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: end;
    margin-left: 16px;
    user-select: none;
    width: 100px;
`;

const ImportButton = styled.div<{ isDisabled: boolean }>`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    ${({ isDisabled }) => isDisabled && `pointer-events: none;`}
    .SWReactIcons {
        margin-right: 6px;
        margin-top: 1px;
        svg {
            path {
                ${({ isDisabled }) => `fill: ${isDisabled ? DISABLED_COLOR : DEFAULT_COLOR} !important;`}
                fill-opacity: 1;
            }
        }
    }
    ${({ isDisabled }) =>
        !isDisabled &&
        ` &:hover {
            ${ButtonText} {
                color: ${BOLD_COLOR};            
            }
            .SWReactIcons {
                margin-right: 6px;
                svg {
                    path {
                        fill: ${BOLD_COLOR} !important;
                    }
                 }
            }
        }
    `}
`;

const ButtonText = styled.span<{ isDisabled: boolean }>`
    ${({ isDisabled }) => `
            ${setFont({
                $color: isDisabled ? DISABLED_COLOR : DEFAULT_COLOR,
                $size: 14,
                $weight: 700,
                $family: "DM Sans",
            })}
    
    `}
`;

// Local replacement for deleted component
const CSVFileSuccessImage = styled.div`
    width: 80px;
    height: 80px;
    background-image: url("/images/file-success.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
`;

export const StyledCSVFileSuccessImage = styled(CSVFileSuccessImage)`
    margin: 18px auto 0px auto;
`;
